// The Comic Machine - API

var API = (function() {

  var environment = "stage";

  var hosts = {
    local: "http://localhost:8090", // HACK: Move to environment var
    stage: "https://api.stage.thecomicmachine.com",
    production: "https://api.thecomicmachine.com",
  };

  var assets = {
    local: "http://localhost:8090/assets", // HACK: Move to environment var
    stage: "https://assets.stage.thecomicmachine.com",
    production: "https://assets.thecomicmachine.com",
  };

  // Configuration settings/properties
  var config = {
    domain: hosts[environment] + (environment === "local" ? "/" : ""),
    base: hosts[environment] + "/api/v1",
    assets: assets[environment],
  };

  // Method to make a request
  var API = {

    config: config,
    authenticated: false,
    token: null,
    user: null,
    cachable: supportsLocalStorage(),

    cache: {
      set: function(key, value) {
        return API.cachable && window.localStorage.setItem(key, value);
      },
      get: function(key) {
        return API.cachable && window.localStorage.getItem(key);
      },
      remove: function(key) {
        return API.cachable && window.localStorage.removeItem(key);
      },
    },

    // User related methods
    users: {

      // Method to create the user
      create: function(data, callback) {

        // Set the request details
        var request = {
          url: config.base + "/users/" + data.email,
          method: "POST",
          type: "application/json",
          loader: {
            text: "Creating Account..."
          },
          data: data,
        };

        // Send the request and handle the response
        Request.send(request, function(success, response) {
          // API.token = success ? response.token : null;
          // API.user = success && data.email;
          // API.authenticated = success && API.token;
          // if (success && API.cachable) {
          //    API.cache.set("tcm-user-token", API.token);
          //    API.cache.set("tcm-user-user", API.user);
          // }
          callback && callback(success, response);
        });

      },

      // Method to log the user in
      login: function(data, callback) {

        // Set the request details
        var request = {
          url: config.base + "/login",
          method: "POST",
          type: "application/json",
          loader: {
            text: "Logging in..."
          },
          data: data,
        };

        // Send the request and handle the response
        Request.send(request, function(success, response) {
          API.token = success ? response.token : null;
          API.user = success && data.email;
          API.authenticated = success && API.token;
          if (success && API.cachable) {
            API.cache.set("tcm-user-token", API.token);
            API.cache.set("tcm-user-user", API.user);
          }
          callback && callback(success, response);
        });

      },

      // Method to authenticate user token
      authenticate: function(data, callback) {

        // Set the request details
        var request = {
          url: config.base + "/authenticate",
          method: "POST",
          type: "application/json",
          data: data,
          loader: {
            text: "Logging in...",
          },
          headers: {
            "x-user-auth-token": API.token,
            "x-user-auth-email": API.user,
          },
        };

        // Send the request and handle the response
        Request.send(request, function(success, response) {
          API.token = success ? response.token : null;
          API.user = success && API.user;
          API.authenticated = success && API.token;
          callback && callback(success, response);
        });

      },

      // Method to log the user out
      logout: function(data, callback) {

        // Set the request details
        var request = {
          url: config.base + "/logout",
          method: "POST",
          type: "application/json",
          data: data,
          loader: {
            text: "Logging out...",
          },
          headers: {
            "x-user-auth-token": API.token,
            "x-user-auth-email": API.user,
          },
        };

        // Send the request and handle the response
        Request.send(request, function(success, response) {
          API.token = null;
          API.user = null;
          API.authenticated = false;
          if (API.cachable) {
            API.cache.remove("tcm-user-token", API.token);
            API.cache.remove("tcm-user-user", API.user);
          }
          callback && callback(success, response);
        });

      }

    },

    // Comic related methods
    comics: {

      // Method to create a new comic
      create: function(data, callback) {

        // Set the request details
        var request = {
          url: config.base + "/comics",
          method: "POST",
          type: "application/json",
          data: data,
          loader: {
            text: "Creating...",
          },
          headers: {
            "x-user-auth-token": API.token,
            "x-user-auth-email": API.user,
          },
        };

        // Send the request and handle the response
        Request.send(request, function(success, response) {
          callback && callback(success, response);
        });

      },

      // Method to update a comic
      update: function(data, callback) {

        var message = "Saving"; // data.published === true ? "Publishing" :

        // Set the request details
        var request = {
          url: config.base + "/comics/" + data.uid,
          method: "PUT",
          type: "application/json",
          data: data,
          loader: {
            text: message + "...",
          },
          headers: {
            "x-user-auth-token": API.token,
            "x-user-auth-email": API.user,
          },
        };

        // Send the request and handle the response
        Request.send(request, function(success, response) {
          callback && callback(success, response);
        });

      },

      // Method to query comics
      query: function(data, callback) {

        var url = config.base + "/comics";
        var published = data.published === true;

        if (data.uid) {
          url += "/" + data.uid;
        }

        if (published) {
          url += "?published=true";
        }

        // Set the request details
        var request = {
          url: url,
          method: "GET",
          type: "application/json",
          data: data,
          loader: {
            close: data.keepNotification ? false : true,
          },
          headers: {
            "x-user-auth-token": API.token,
            "x-user-auth-email": API.user,
          },
        };

        // Send the request and handle the response
        Request.send(request, function(success, response) {
          callback && callback(success, response);
        });

      },

      // Method to query public comics
      gallery: function(data, callback) {

        var url = config.base + "/gallery";

        if (data.uid) {
          url += "/" + data.uid;
        }

        // Set the request details
        var request = {
          url: url,
          method: "GET",
          type: "application/json",
          data: data,
          loader: {
            close: data.keepNotification ? false : true,
          },
          headers: {
            "x-user-auth-token": API.token,
            "x-user-auth-email": API.user,
          },
        };

        if (data.access) {
          request.headers["x-comic-access"] = window.btoa(data.access);
        }

        // Send the request and handle the response
        Request.send(request, function(success, response) {
          callback && callback(success, response);
        });

      },

      // Method to remove a comic
      remove: function(data, callback) {

        var url = config.base + "/comics";

        if (data.uid) {
          url += "/" + data.uid;
        }

        // Set the request details
        var request = {
          url: url,
          method: "DELETE",
          type: "application/json",
          data: data,
          loader: {
            text: "Removing...",
          },
          headers: {
            "x-user-auth-token": API.token,
            "x-user-auth-email": API.user,
          },
        };

        // Send the request and handle the response
        Request.send(request, function(success, response) {
          callback && callback(success, response);
        });

      }

    },

    // Asset related methods
    assets: {

      // Method to create a new asset
      create: function(data, callback) {

        // Set the request details
        var request = {
          url: config.base + "/assets",
          method: "POST",
          type: "", //"multipart/form-data",
          data: data,
          loader: {
            text: "Uploading...",
          },
          headers: {
            "x-user-auth-token": API.token,
            "x-user-auth-email": API.user,
          },
        };

        // Send the request and handle the response
        Request.send(request, function(success, response) {
          callback && callback(success, response);
        });

      },

      // Method to query assets
      query: function(data, callback) {

        var url = config.base + "/assets";

        if (data.uid) {
          url += "/" + data.uid;
        }

        if (data.comic) {
          url += "?comic=" + data.comic;
        }

        // Set the request details
        var request = {
          url: url,
          method: "GET",
          type: "application/json",
          data: data,
          loader: {
            close: data.keepNotification ? false : true,
          },
          headers: {
            "x-user-auth-token": API.token,
            "x-user-auth-email": API.user,
          },
        };

        // Send the request and handle the response
        Request.send(request, function(success, response) {
          callback && callback(success, response);
        });

      }

    }

  };

  // Public / exposed class
  return API;

})();
